<template>
	<div>
		<transition-fade>
			<div
				v-if="dialogItem"
				class="fixed inset-0 z-50 flex cursor-auto items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
				@click="closeDialogAndPopper"
			>
				<div
					class="relative flex min-h-[70dvh] w-[95vw] flex-col items-center p-12 shadow-lg sm:min-h-[60dvh] sm:w-[80vw] md:w-[60vw] lg:w-[40vw]"
					@click.stop
				>
					<iframe
						:src="dialogItem.embed"
						frameborder="0"
						style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; border: 0"
					>
					</iframe>
				</div>
			</div>
		</transition-fade>
		<div
			class="fixed bottom-4 right-4 z-50 flex flex-col items-center space-y-4 sm:bottom-8 sm:right-8 sm:space-y-6"
		>
			<transition-group name="slide-in" tag="div">
				<button
					v-for="(item, index) in items"
					:key="item.text"
					:class="[
						'group fixed size-10 rounded-full shadow-lg shadow-black/40 transition duration-300 ease-in-out hover:scale-110 dark:shadow-black/80 sm:size-12',
						item.class,
						`teleflow-bottom-${index} teleflow-right`
					]"
					@click="handleClick(item)"
				>
					<span :class="item.icon" class="text-xl text-white sm:text-2xl"></span>
					<div
						class="absolute right-full mr-2 -translate-y-1/2 transform whitespace-nowrap rounded-lg bg-gray-100 px-2 py-0.5 text-sm text-gray-800 shadow-lg shadow-black/20 dark:bg-gray-700 dark:text-gray-100 dark:shadow-black/60"
						style="top: 50%"
					>
						{{ item.text }}
					</div>
				</button>
			</transition-group>
			<button
				:class="[
					'size-12 transform rounded-full shadow-lg shadow-black/20 transition duration-300 ease-in-out hover:scale-110 dark:shadow-black/60 sm:size-16',
					showPopper ? 'bg-main hover:bg-red-500' : 'bg-main hover:bg-accentMain'
				]"
				@click="togglePopper"
			>
				<span
					:class="
						showPopper
							? 'fa-duotone fa-times-circle text-4xl text-white sm:text-5xl'
							: 'fa-duotone fa-question-circle text-4xl text-white hover:text-main sm:text-5xl'
					"
				></span>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['user', 'showContactFormModal'],
	data() {
		return {
			showPopper: false,
			items: [],
			timeouts: [],
			dialogItem: null
		}
	},
	methods: {
		togglePopper() {
			if (!this.showPopper) {
				this.showPopper = true
				this.addItemsWithDelay()
			} else {
				this.clearPopper()
			}
		},
		handleClick(item) {
			if (item.embed) {
				this.dialogItem = item
			} else if (item.openContactModal) {
				this.showContactFormModal = true
				this.clearPopper()
			} else if (item.mailto) {
				window.open(item.mailto)
			} else {
				window.open(item.external, '_blank')
			}
		},
		closeDialogAndPopper() {
			this.dialogItem = null
			this.clearPopper()
		},
		addItemsWithDelay() {
			const itemsToAdd = [
				{
					text: 'Support',
					class: 'bg-red-500 hover:bg-red-700',
					icon: 'fa-duotone fa-life-ring',
					openContactModal: true
				}
			]

			if (this.user) {
				itemsToAdd.push(
					{
						text: 'Feature Request',
						class: 'bg-yellow-500 hover:bg-yellow-700',
						icon: 'fa-duotone fa-lightbulb',
						embed: `https://feedback.teleflow.co.uk/s/srzm6d27v1qqldmslq9hlm6n?embed=true&userId=${this.user.sub || ''}&email=${this.user.email || ''}&name=${encodeURIComponent(this.user.name || '')}`
					},
					{
						text: 'Feedback',
						class: 'bg-green-500 hover:bg-green-700',
						icon: 'fa-duotone fa-comment-dots',
						embed: `https://feedback.teleflow.co.uk/s/ksqo0woubbt9rmoqstib5ii5?embed=true&userId=${this.user.sub || ''}&email=${this.user.email || ''}&name=${encodeURIComponent(this.user.name || '')}`
					},
					{
						text: 'Documentation',
						class: 'bg-blue-500 hover:bg-blue-700',
						icon: 'fa-duotone fa-book',
						external: `https://docs.teleflow.app/`
					}
				)
			}

			itemsToAdd.forEach((item, index) => {
				this.timeouts.push(
					setTimeout(() => {
						if (this.showPopper) {
							this.items.push(item)
						}
					}, index * 250)
				)
			})
		},
		clearPopper() {
			this.timeouts.forEach((timeout) => clearTimeout(timeout))
			this.timeouts = []
			this.items = []
			this.showPopper = false
		}
	}
}
</script>

<style scoped>
.slide-in-enter-active,
.slide-in-leave-active {
	transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	transform: translateX(0px);
}
.slide-in-enter-from,
.slide-in-leave-to {
	opacity: 0;
	transform: translateX(50px);
}

.teleflow-bottom-0 {
	bottom: 5.5rem;
}

.teleflow-bottom-1 {
	bottom: 9rem;
}

.teleflow-bottom-2 {
	bottom: 12.5rem;
}

.teleflow-bottom-3 {
	bottom: 16rem;
}

.teleflow-right {
	right: 1.25rem;
}

@media (min-width: 768px) {
	.teleflow-bottom-0 {
		bottom: 7.5rem;
	}

	.teleflow-bottom-1 {
		bottom: 12.5rem;
	}

	.teleflow-bottom-2 {
		bottom: 17.5rem;
	}

	.teleflow-bottom-3 {
		bottom: 22.5rem;
	}

	.teleflow-right {
		right: 2.5rem;
	}
}
</style>
